var _path, _path2, _rect, _rect2, _path3, _path4, _rect3, _rect4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSeats(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 78,
    viewBox: "0 0 124 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "seats-stroke-primary",
    d: "M85.283 35.4248H102.818",
    stroke: "#B0A899",
    strokeWidth: 6,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "seats-stroke-primary",
    d: "M75.8411 6.80566L88.889 54.699H116.658",
    stroke: "#B0A899",
    strokeWidth: 13,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "seats-fill-secondary",
    fill: "#C6BEB3",
    x: 80.5266,
    y: 2.49756,
    width: 7.90366,
    height: 18.3614,
    rx: 3.95183,
    transform: "rotate(-15.1856 80.5266 2.49756)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "seats-fill-secondary",
    fill: "#C6BEB3",
    x: 83.4259,
    y: 68.2261,
    width: 40.074,
    height: 9.77415,
    rx: 4.88707
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "seats-stroke-primary",
    d: "M16.9421 35.4243H34.477",
    stroke: "#B0A899",
    strokeWidth: 6,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "seats-stroke-primary",
    d: "M7.50024 6.80518L20.5481 54.6985H48.3171",
    stroke: "#B0A899",
    strokeWidth: 13,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "seats-fill-secondary",
    fill: "#C6BEB3",
    x: 12.1858,
    y: 2.49707,
    width: 7.90366,
    height: 18.3614,
    rx: 3.95183,
    transform: "rotate(-15.1856 12.1858 2.49707)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "seats-fill-secondary",
    fill: "#C6BEB3",
    x: 15.0851,
    y: 68.2261,
    width: 40.074,
    height: 9.77415,
    rx: 4.88707
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeats);
export default __webpack_public_path__ + "static/media/seats.625f7575.svg";
export { ForwardRef as ReactComponent };